<script setup lang="ts">
import { UiLinkField, UiText } from "@shopexperts/shared";
import { quoteCopy } from "@/v2Projects/utils/quoteCopy";

defineProps<{
  invoiceUrl?: string | null;
}>();

defineEmits<{
  copySuccess: [value: string];
}>();
</script>

<template>
  <section class="flex flex-col gap-2">
    <UiText as="h3" variant="p" class="font-semibold text-se-dark">
        {{ quoteCopy.proposalDetails.invoiceUrlLabel }}
    </UiText>
    <UiLinkField
      v-if="invoiceUrl"
      :value="invoiceUrl"
      :copy-label="quoteCopy.proposalDetails.copyAction"
      @copy-success="$emit('copySuccess', $event)"
    />
    <UiText v-else as="p" variant="p-small" class="rounded-lg border border-se-gray-300 bg-se-gray-100/50 p-4 text-se-gray-500">
      {{ quoteCopy.proposalDetails.invoiceMissingFallback }}
    </UiText>
  </section>
</template>
